import { extractUrlFromIconJsonLd } from '@atlaskit/link-extractors';
var extractUrlIcon = function extractUrlIcon(icon, label) {
  var url = icon && extractUrlFromIconJsonLd(icon);
  return url ? {
    label: label,
    url: url
  } : undefined;
};
export default extractUrlIcon;